import { Button } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const StyledButton = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: ({ invert }) =>
      invert ? `0.125rem solid ${theme.palette.button.main}` : 'none',
    borderRadius: '100rem',
    padding: '0.5rem 1.5rem',
    background: ({ invert }) =>
      invert
        ? 'none'
        : `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
    fontFamily: '"Lato", sans-serif',
    color: ({ invert }) => (invert ? theme.palette.button.text : 'white'),

    '&:disabled': {
      background: '#e7ebed !important',
      color: '#b7b7b7 !important',
      cursor: 'not-allowed'
    }
  }
}))(Button)

export default StyledButton
